import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SummarydataService {
  summaryData:any
  constructor() { }

  setSummaryData(data:any){
    this.summaryData = data;
  }

  getSummaryData(){
    return this.summaryData;
  }
}
